import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import reconciliation from "@safecv/assets/Images/reconciliation_new.svg";
import document from "@safecv/assets/Images/document.svg";
import pdf from "@safecv/assets/Images/pdf.svg";
import documentTick from "@safecv/assets/Images/document-tick.svg";
import pdfTick from "@safecv/assets/Images/pdf-tick.svg";
import greenTick from "@safecv/assets/Images/greenTick.svg";
import redCircleRemove from "@safecv/assets/Images/remove_circle.svg";
import greenCircleTick from "@safecv/assets/Images/check_circle_greentick.svg";

import SupportDocLoader from "./SupportDocLoader";
import Profile from "@safecv/core/Profile";
import MenuComponent from "./MenuComponent";
import ModalComponent from "./ModalComponent";
import DesignCriteriaMenu from "./DesignCriteriaMenu";
import ViewDetailComponent from "./ViewDetailComponent";
import DownloadMenuComponent from "./DownloadMenuComponent";
import Step from "./Step";

import { verficationStatus } from "@safecv/actions/postActions";

import "./Header.css";

function Header(props) {
  //props received from parent component can be used
  const [isCompleteTaskModalOpen, setIsCompleteTaskModalOpen] = useState(false);
  const [isDiscardTaskModalOpen, setIsDiscardTaskModalOpen] = useState(false);
  const [discardReasonText, setDiscardReasonText] = useState("");
  const [headerHeight, setHeaderHeight] = useState(56);
  const [currentDoc, setCurrentDoc] = useState(props.planName);
  const [isApprove, setIsApprove] = useState(true);
  const [approveRejectText, setApproveRejectText] = useState("");

  const refHeader = useRef(null);
  const ellipsisData = [
    {
      label: "Discard agent results",
    },
  ];

  const {
    isSidebarOpen,
    setIsSidebarOpen,
    isPdfSelected,
    setIsPdfSelected,
    isDocumentSelected,
    setIsdocumentSelected,
    planName,
    jobId,
    planStatus,
    verficationStatus,
    planDetails,
    setSelectedStampDocument,
    setIsReconciliationSidebarOpen,
    setViewType,
    isSupportDocSelected,
    setSupportdocSelection,
    setCurrentDocVal,
    setIsCommentRepoSelected,
    algoEnabled,
  } = props;

  const isPlanTypeCommercial =
    planDetails.planType.toLowerCase() === "commercial";

  const updateHeaderHeight = () => {
    setHeaderHeight(refHeader.current.clientHeight);
  };
  useEffect(() => {
    setCurrentDocVal(currentDoc);
  }, [currentDoc]);

  useEffect(() => {
    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  useEffect(() => {
    // to close the sidebar when comments are open
    !isPdfSelected &&
      isDocumentSelected &&
      isSidebarOpen &&
      setIsSidebarOpen(false);
  }, [isPdfSelected, isDocumentSelected]);

  const pdfClick = () => {
    setSupportdocSelection(false);
    setIsPdfSelected(!isPdfSelected);
  };

  const stampCommentClick = () => {
    setIsdocumentSelected(false);
    setIsCommentRepoSelected(false);
    setIsPdfSelected(!isPdfSelected);
  };

  const commentLetterClick = () => {
    setSupportdocSelection(false);
    setIsdocumentSelected(!isDocumentSelected);
    isDocumentSelected && !isPdfSelected && setIsPdfSelected(true);
  };

  const reconcilationClick = () => {
    setIsReconciliationSidebarOpen(true);
    setSupportdocSelection(false);
    setIsdocumentSelected(false);
  };

  // will hold the plan name, plan information, document types to display,
  // panel view, complete verification, and about the user etc.
  return (
    <div ref={refHeader} className="landing-header-container">
      <div className="header-left">
        <Link to={{ pathname: "/plans", search: `${props.queryparams}` }}>
          <div className="arrow left" />
        </Link>
        <div className="header-plan-name" title={planName}>
          {planName}
        </div>

        {!isPlanTypeCommercial && algoEnabled && (
          <React.Fragment>
            <div className="separator-line" />
            <DesignCriteriaMenu jobId={jobId} headerHeight={headerHeight} />
            <img
              alt=""
              src={reconciliation}
              className="doc-icons"
              style={{ width: "23px" }}
              title="Reconciliation Report"
              onClick={reconcilationClick}
            />
          </React.Fragment>
        )}
        <div className="separator-line" />

        <ViewDetailComponent
          planDetails={planDetails}
          headerHeight={headerHeight}
        />
        <div className="separator-line" />
        <Step status={planStatus.toLowerCase()} />
      </div>

      <SupportDocLoader
        planName={planName}
        jobId={jobId}
        isSupportDocSelected={isSupportDocSelected}
        setCurrentDoc={setCurrentDoc}
      />
      <div className="header-right">
        <div className="separator-line" />
        <div className="doc-icons" onClick={pdfClick}>
          {isPdfSelected ? (
            <img src={pdfTick} alt="" />
          ) : (
            <img src={pdf} alt="" />
          )}
        </div>
        <div className="doc-icons" onClick={commentLetterClick}>
          <Link
            to={{
              pathname: "/plan/" + encodeURIComponent(jobId) + "/commentletter",
              search: `${props.queryparams}`,
            }}
          >
            {isDocumentSelected ? (
              <img src={documentTick} alt="" />
            ) : (
              <img src={document} alt="" />
            )}
          </Link>
        </div>
        <div className="separator-line" />

        {planStatus.toLowerCase() === "verify" && (
          <div
            className="header-complete-button"
            onClick={() => setIsCompleteTaskModalOpen(true)}
          >
            Complete task
          </div>
        )}
        {["verified", "discarded"].includes(planStatus.toLowerCase()) && (
          <div
            className={`header-complete-button ${
              planStatus.toLowerCase() === "discarded" ||
              (planDetails?.approvalStatus &&
                planDetails.approvalStatus.toLowerCase() === "rejected")
                ? "discarded-text"
                : "completed-text"
            }`}
          >
            {planStatus.toLowerCase() === "discarded" ? (
              "Discarded"
            ) : planDetails?.approvalStatus &&
              planDetails.approvalStatus.toLowerCase() === "approved" ? (
              <>
                <img
                  alt=""
                  src={greenCircleTick}
                  className="plan-complete-tick"
                />
                Approved
              </>
            ) : planDetails?.approvalStatus &&
              planDetails.approvalStatus.toLowerCase() === "rejected" ? (
              <>
                <img
                  alt=""
                  src={redCircleRemove}
                  className="plan-complete-tick"
                />
                Rejected
              </>
            ) : (
              <>
                <img alt="" src={greenTick} className="plan-complete-tick" />
                Completed
              </>
            )}
          </div>
        )}
        <DownloadMenuComponent jobId={jobId} headerHeight={headerHeight} />
        {!isPlanTypeCommercial && (
          <MenuComponent
            item={ellipsisData}
            planStatus={planStatus}
            headerHeight={headerHeight}
            setIsDiscardTaskModalOpen={setIsDiscardTaskModalOpen}
          />
        )}
        <div>
          <Profile />
        </div>
      </div>
      {/* Complete task modal */}
      <ModalComponent
        widthContainer="30%"
        buttonText="Complete"
        modalHeading="Complete Task"
        isModalOpen={isCompleteTaskModalOpen}
        handleClose={() => {
          setApproveRejectText("");
          setIsCompleteTaskModalOpen(false);
        }}
        modalBody={
          <div>
            <div>
              Inorder to complete task, please select whether the reviewed plan
              is Approved or Rejected.
            </div>
            <div className="approve-buttons-container">
              <div
                className={`approve-reject-buttons ${
                  isApprove ? "approve-button" : ""
                }`}
                onClick={() => setIsApprove(true)}
              >
                <img
                  alt=""
                  src={greenCircleTick}
                  className={`approve-buttons-images ${
                    isApprove ? "" : "approve-image-disable"
                  }`}
                />
                Approve
              </div>
              <div
                className={`approve-reject-buttons ${
                  isApprove ? "" : "reject-button"
                }`}
                onClick={() => setIsApprove(false)}
              >
                <img
                  alt=""
                  src={redCircleRemove}
                  className={`approve-buttons-images ${
                    isApprove ? "approve-image-disable" : ""
                  }`}
                />
                Reject
              </div>
            </div>
            <div className="approval-comments"> Comments </div>
            <textarea
              type="text"
              value={approveRejectText}
              className="complete-task-textarea"
              placeholder="Approval/Denial Message"
              onChange={(e) => setApproveRejectText(e.target.value)}
            />
          </div>
        }
        handleConfirm={() =>
          verficationStatus(jobId, planName, "VERIFIED", {
            approvalStatus: isApprove ? "Approved" : "Rejected",
            notes: approveRejectText,
          })
        }
      />
      {/* Reject task modal */}
      <ModalComponent
        widthContainer="30%"
        buttonText="Discard"
        isModalOpen={isDiscardTaskModalOpen}
        modalHeading="Reason for Discarding Task"
        handleClose={() => {
          setDiscardReasonText("");
          setIsDiscardTaskModalOpen(false);
        }}
        modalBody={
          <textarea
            type="text"
            value={discardReasonText}
            className="discard-task-textarea"
            placeholder="Reason for discard"
            onChange={(e) => setDiscardReasonText(e.target.value)}
          />
        }
        handleConfirm={() =>
          verficationStatus(jobId, planName, "DISCARDED", {
            notes: discardReasonText,
          })
        }
      />
    </div>
  );
}

const mapStatetoProps = (state) => ({
  queryparams: state.plans.queryparams,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    verficationStatus: (jobId, planName, status, reasonForReject) => {
      dispatch(verficationStatus(jobId, planName, status, reasonForReject));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(Header);
